import React, { useState, useEffect } from "react";
import "./Loader.scss";

const Loader = ({ message = "Loading" }) => {
  const [dots, setDots] = useState("");

  // Create animated dots effect for the loading message
  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => {
        if (prev.length >= 3) return "";
        return prev + ".";
      });
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="loader-container">
      <div className="loader-card">
        <div className="loader"></div>
        <div className="loader-text">
          {message}
          {dots}
        </div>
        <div className="loader-dot"></div>
      </div>
    </div>
  );
};

export default Loader;
